import * as Sentry from "@sentry/react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'react-toastify/dist/ReactToastify.css';
//import './assets/css/style.css';
import {  
  HOME_LINK,
  LOGIN_LINK,
  CAMPAIGN_ALL_LINK,
  CAMPAIGN_CREATE_LINK,
  CAMPAIGN_UPDATE_LINK,
  CREATE_RECIPIENTS_IN_CAMPAIGN_LINK,
  COMPOSE_MESSAGE_FOR_CAMPAIGN_LINK, 
  MESSAGE_PREVIEW_FOR_CAMPAIGN_LINK,
  CREATE_GOOGLE_SMTP_ACCOUNT_LINK,
  EDIT_GOOGLE_SMTP_ACCOUNT_LINK,
  EDIT_CAMPAIGN_LINK,
  OPTIONS_FOR_CAMPAIGN_LINK,
  FINAL_STEP_FOR_CAMPAIGN_LINK,
  RESET_PASSWORD_LINK,
  FORGOT_PASSWORD_LINK,
  LOGOUT_LINK,
  CAMPAIGN_OVERVIEW_URL,
  CAMPAIGN_SEQUENCE_URL,
  CAMPAIGN_RECIPIENTS_URL,
  CAMPAIGN_SETTINGS_URL,
  CAMPAIGN_LEADS_URL,
  MAIL_ACCOUNT_ALL_LINK,
  MAIL_ACCOUNT_CREATE_LINK,
  CAMPAIGN_CALENDAR_URL,
  TEAMMATES_LINK,
  CONTACT_ALL_LINK,
  GOOGLE_CLIENT_ID,
  RECONNECT_GOOGLE_ACCOUNT_LINK,
  EDIT_SMTP_ACCOUNT_LINK,
  EDIT_SEQUENCE_LINK,
  TEST_UNSUBSCRIBE_LINK, 
  UNSUBSCRIBERS_LINK}             from './constants/constants';
import HomePage                   from './components/HomePage';
import LoginPage                  from './components/LoginPage';
import LogoutPage                 from './components/LogoutPage';
import ResetPasswordPage          from './components/ResetPasswordPage';
import ForgotPasswordPage         from './components/ForgotPasswordPage';
import TestUnsubscribe            from './components/TestUnsubscribe';
import UpdateCampaign             from './components/campaigns/UpdateCampaign';
import AddCampaign                from './components/campaigns/AddCampaign';
import EditCampaign               from './components/campaigns/EditCampaign';
import AllCampaigns               from './components/campaigns/AllCampaigns';
import CampaignOverview           from './components/campaigns/CampaignOverview';
import CampaignSequence           from './components/campaigns/CampaignSequence';
import CampaignRecipients         from './components/campaigns/CampaignRecipients';
import CampaignSettings           from './components/campaigns/CampaignSettings';
import AddRecipientsInCampaign    from './components/campaigns/AddRecipientsInCampaign';
import ComposeMessageForCampaign  from './components/campaigns/ComposeMessageForCampaign';
import CampaignMessagePreview  from './components/campaigns/CampaignMessagePreview';
import OptionsForCampaign         from './components/campaigns/OptionsForCampaign';
import FinalStepForCampaign       from './components/campaigns/FinalStepForCampaign';
import EditSequence               from './components/campaigns/EditSequence';
import AllMailAccounts            from './components/mail-accounts/AllMailAccounts';
import CreateMailAccounts         from './components/mail-accounts/CreateMailAccounts';
import EditSmtpMailAccounts       from './components/mail-accounts/EditSmtpMailAccounts';
import ReconnectGoogleMailAccount from './components/mail-accounts/ReconnectGoogleMailAccount';
import CreateGoogleSmtpAccount    from './components/mail-accounts/CreateGoogleSmtpAccount';
import EditGoogleSmtpAccount      from './components/mail-accounts/EditGoogleSmtpAccount';
import CampaignCalendar           from './components/campaigns/CampaignCalendar';
import TeamMates                  from './components/team/TeamMates';
import Contacts                   from './components/contact/Contacts';
import PageNotFound               from './components/PageNotFound';
import MultiStepForm              from './components/MultiStepForm';
import Unsubscribers              from './components/contact/Unsubscribers';
import CampaignLeads              from './components/leads/CampaignLeads';


if (typeof process.env.SENTRY_DSN !== "undefined"){
    
    Sentry.init({
        dsn: process.env.SENTRY_DSN,
        integrations: [
            Sentry.browserTracingIntegration(),
            //Sentry.replayIntegration(),
        ],
        tracesSampleRate: process.env.APP_ENV === 'production' ? 0.1 : 1.0,
        replaysSessionSampleRate: process.env.APP_ENV === 'production' ? 0.1 : 1.0,
        replaysOnErrorSampleRate: 1.0,
        environment: process.env.APP_ENV
    });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div className="wrapper">
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <Router>
      <Routes>
        <Route exact path={HOME_LINK} element={<HomePage />} />
        <Route exact path={'/demo'} element={<MultiStepForm />} />
        <Route exact path={LOGIN_LINK} element={<LoginPage />} />
        <Route path={RESET_PASSWORD_LINK} element={<ResetPasswordPage />} />
        <Route exact path={FORGOT_PASSWORD_LINK} element={<ForgotPasswordPage />} />
        <Route exact path={LOGOUT_LINK} element={<LogoutPage />} />
        <Route exact path={CAMPAIGN_ALL_LINK} element={<AllCampaigns />} />
        <Route exact path={CAMPAIGN_CREATE_LINK} element={<AddCampaign />} />
        <Route exact path={CAMPAIGN_UPDATE_LINK} element={<UpdateCampaign />} />
        <Route exact path={EDIT_CAMPAIGN_LINK} element={<EditCampaign />} />
        <Route exact path={CREATE_GOOGLE_SMTP_ACCOUNT_LINK} element={<CreateGoogleSmtpAccount />} />
        <Route exact path={EDIT_GOOGLE_SMTP_ACCOUNT_LINK} element={<EditGoogleSmtpAccount />} />
        <Route exact path={CREATE_RECIPIENTS_IN_CAMPAIGN_LINK} element={<AddRecipientsInCampaign />} />
        <Route exact path={COMPOSE_MESSAGE_FOR_CAMPAIGN_LINK} element={<ComposeMessageForCampaign />} />
        <Route exact path={MESSAGE_PREVIEW_FOR_CAMPAIGN_LINK} element={<CampaignMessagePreview />} />
        <Route exact path={OPTIONS_FOR_CAMPAIGN_LINK} element={<OptionsForCampaign />} />
        <Route exact path={FINAL_STEP_FOR_CAMPAIGN_LINK} element={<FinalStepForCampaign />} />
        <Route exact path={CAMPAIGN_CALENDAR_URL} element={<CampaignCalendar />} />        
        <Route exact path={CAMPAIGN_OVERVIEW_URL} element={<CampaignOverview />} />
        <Route exact path={CAMPAIGN_SEQUENCE_URL} element={<CampaignSequence />} />
        <Route exact path={EDIT_SEQUENCE_LINK} element={<EditSequence />} />
        <Route exact path={CAMPAIGN_RECIPIENTS_URL} element={<CampaignRecipients />} />
        <Route exact path={CAMPAIGN_SETTINGS_URL} element={<CampaignSettings />} />
        <Route exact path={CAMPAIGN_LEADS_URL} element={<CampaignLeads />} />
        <Route exact path={CONTACT_ALL_LINK} element={<Contacts />} />
        <Route exact path={UNSUBSCRIBERS_LINK} element={<Unsubscribers />} />
        <Route exact path={MAIL_ACCOUNT_ALL_LINK} element={<AllMailAccounts />} />
        <Route exact path={MAIL_ACCOUNT_CREATE_LINK} element={<CreateMailAccounts />} />        
        <Route exact path={EDIT_SMTP_ACCOUNT_LINK} element={<EditSmtpMailAccounts />} />
        <Route exact path={RECONNECT_GOOGLE_ACCOUNT_LINK} element={<ReconnectGoogleMailAccount />} />
        <Route exact path={TEAMMATES_LINK} element={<TeamMates />} />
        <Route exact path={TEST_UNSUBSCRIBE_LINK} element={<TestUnsubscribe />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>  
    </Router> 
    </GoogleOAuthProvider>
  </div>
);